export default {
  ENTER_KEY: 'Enter',
  MAX_DESCRIPTION_LENGTH: 160,
  MAX_TITLE_TAG_LENGTH: 70,
  MAX_PAGE_NAME_LENGTH: 70,
  MAX_KEYWORDS_COUNT: 100,
  MAX_PATH_LENGTH: 500,
  /* eslint-disable no-useless-escape */
  LETTER_OR_NUMBER_REGEXP: /[\p{L}0-9]+/u,
  PUBLISH_PATH_REGEXP: /^\/([\p{L}0-9-_.]+\/?)*$/u,
  /* eslint-enable no-useless-escape */
  PUBLISH_PATH_RESERVED_REGEXP: /\/(ws|e)(?=$|\/)|^\/cart\/?$/i,
  DEFAULT_SITE_URL: 'https://yoursitedomain',
  ADD_PAGE_DIALOG_MOBILE_WIDTH: 314,
  ADD_PAGE_DIALOG_WIDTH: 360,
};
